export default "__VITE_ASSET__Cid5C6HT__"